import React, { Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';

import { observer } from 'mobx-react';

import Fallback from 'bz-core-controls/controls/lazy/controls/fallback';

import withDisplayName from 'bz-utilities/hoc/display-name';

const LoginRegister = React.lazy(() => import('../../../modules/auth'));
const AutoLogin = React.lazy(() => import('../../../modules/auth/controls/auto-login'));
const MakeBooking = React.lazy(() => import('../../../modules/book'));
const BuyPackage = React.lazy(() => import('../../../modules/buy-package'));
const ChasePayment = React.lazy(() => import('../../../modules/chased-payment'));
const CompleteForm = React.lazy(() => import('../../../modules/complete-form'));
const ConfirmWaitingList = React.lazy(() => import('../../../modules/confirm-waiting-list'));
const Dashboard = React.lazy(() => import('../../../modules/dashboard'));
const ExplorePackages = React.lazy(() => import('../../../modules/explore-packages'));
const Integration = React.lazy(() => import('../../../modules/integration'));
const MyAccount = React.lazy(() => import('../../../modules/my-account'));
const MyCases = React.lazy(() => import('../../../modules/my-cases'));
const MyDiary = React.lazy(() => import('../../../modules/my-diary'));
const RequestAccessToken = React.lazy(() => import('../../../modules/request-access-token'));
const ResetPassword = React.lazy(() => import('../../../modules/reset-password'));
const Terms = React.lazy(() => import('../../../modules/terms'));
const VideoAppointment = React.lazy(() => import('../../../modules/video-appointment'));
const SomethingWentWrongScreen = React.lazy(() => import('../redirect-error'));
const RedirectPage = React.lazy(() => import('../redirect-screen'));
const NoMatch = React.lazy(() => import('./controls/no-match'));
const UnauthenticatedPage = React.lazy(
  () => import('src/modules/auth/controls/unauthenticated-page')
);

export interface IProps {}

const ContentRoutes = observer(
  withDisplayName<IProps>(() => {
    return (
      <Suspense fallback={<Fallback />}>
        <Switch>
          <Route path="/integration" component={Integration} />
          <Route path="/login" exact component={LoginRegister} />
          <Route path="/login/reset/:resetCode" exact component={ResetPassword} />
          <Route path="/requestaccesstoken" exact component={RequestAccessToken} />
          <Route path="/launch" exact component={AutoLogin} />
          <Route path="/myaccount" component={MyAccount} />
          <Route path="/cases" component={MyCases} />
          <Route path="/terms" exact component={Terms} />
          <Route path="/diary" exact component={MyDiary} />
          <Route path="/packages" exact component={ExplorePackages} />
          <Route path="/form/:formId" exact component={CompleteForm} />
          <Route path="/go/:waitingListId" exact component={ConfirmWaitingList} />
          <Route path="/book" component={MakeBooking} />
          <Route path="/packages/:slug" exact component={BuyPackage} />
          <Route path="/pay/:chaseId" exact component={ChasePayment} />
          <Route path="/join/:videoId" exact component={VideoAppointment} />
          <Route path="/join" exact component={VideoAppointment} />
          <Route path="/redirecterror" component={SomethingWentWrongScreen} />
          <Route path="/redirect" exact component={RedirectPage} />
          <Route path="/unauthenticated" exact component={UnauthenticatedPage} />
          <Route path="/" exact component={Dashboard} />
          <Route component={NoMatch} />
        </Switch>
      </Suspense>
    );
  }, 'ContentRoutes')
);

export default ContentRoutes;
